import { useEffect, useState } from "react";

let globalAppReady = false;

export function appReady() {
  globalAppReady = true;
  window.dispatchEvent(new Event("walter.app.ready"));
}

/**
 * Hook to check if the Walter app has been fully initialized and is ready for use.
 *
 * This includes:
 * - User authentication validation
 * - Schema loading and validation
 * - Document state synchronization
 * - Migration execution
 * - All data needed for the app to function
 */
export const useAppReady = () => {
  const [ready, setReady] = useState(globalAppReady);

  useEffect(() => {
    if (globalAppReady) setReady(true);

    const handleAppReady = () => setReady(true);
    window.addEventListener("walter.app.ready", handleAppReady);
    return () => window.removeEventListener("walter.app.ready", handleAppReady);
  }, []);

  return { isAppReady: ready, setAppReady: setReady };
};
